import { Injectable } from '@angular/core';
import { Request, Version } from '../models/tracer.model';

@Injectable({
  providedIn: 'root',
})
export class TraceUtilsService {
  versions: { [key: string]: Version } = {};

  constructor() {}

  setVersions(versions: any) {
    this.versions = versions;
  }

  getEnv(request: Request): string {
    return request?.version_id && this.versions[request.version_id]?.env
      ? this.versions[request.version_id]?.env
      : '(not set)';
  }

  getHash(request: Request): string {
    return request?.version_id && this.versions[request.version_id]?.hash
      ? this.versions[request.version_id]?.hash
      : '(not set)';
  }

  getProviders(request: Request): string {
    // For multi-provider requests (typically AirShopping fanning out to
    // several NDC/Kyte providers) render "*" instead of expanding the
    // list. Two equivalent inputs need to map to "*":
    //
    //   1. Multiple requester traces with different Providers values
    //      (e.g. one trace per provider after fan-out).
    //   2. A single Providers value that already represents intent —
    //      either the literal "*" wildcard or a comma-separated list
    //      like "EK,CM,AV,BA,A3" (sidecar carries consumer intent
    //      verbatim, which can land on traces.providers OR fall back
    //      via request.provider).
    //
    // Collapse both into "*" so the dashboard reads consistently
    // regardless of which capture path landed first.
    const isMultiIntent = (v: string | undefined | null): boolean =>
      !!v && (v === '*' || v.includes(','));

    const traceProviders = (request?.traces ?? [])
      .filter(t => t.source === 'requester' && !!t.providers)
      .map(t => t.providers);

    if (traceProviders.some(isMultiIntent)) return '*';

    const distinct = new Set(traceProviders);
    if (distinct.size > 1) return '*';
    if (distinct.size === 1) return distinct.values().next().value ?? '(not set)';

    // Fallback to request.provider — same multi-intent collapse.
    if (isMultiIntent(request?.provider)) return '*';
    return request?.provider || '(not set)';
  }
}
